import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";

export const getProductFamiliesList = createAction(
    "[Products] Get All Product Families List Action",
    props<{ options: any }>()
  );
  export const loadProductFamiliesList = createAction(
    "[Products] Load All Product Families List Action",
    props<{ response: any[] }>()
  );
  export const getProductFamiliesExcelList = createAction(
    "[Products] Get All Product Families Excel List Action",
    props<{ options: any }>()
  );
  export const loadProductFamiliesExcelList = createAction(
    "[Products] Load All Product Families Excel List Action",
    props<{ response: any[] }>()
  );
  export const createProductFamily = createAction(
    "[Products] Create Product Family Action",
    props<{ productFamily: any }>()
  );
  export const updateProductFamily = createAction(
    "[Products] Update Product Family Action",
    props<{ productFamily: any }>()
  );
  export const getProductFamily = createAction(
    "[Products] Get Product Family Action",
    props<{ code: string }>()
  );
  export const loadProductFamily = createAction(
    "[Products] Load Product Family Action",
    props<{ response: any }>()
  );
  export const resetProductFamily = createAction("[Products] Reset Product Action");
  export const resetCreation = createAction("[Products] Reset Product Family Creation Action");
